import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { VoiceCustomerCallTypeSummarySearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportVoiceCustomerCallTypeSummary, sortVoiceCustomerCallTypeSummary } from '../../constants';
import { getVolumeAmountByUsageType, getListAllVolumeAmountByUsageType, onResetDefaultData } from '../../actions';
import { makeGetListVolumeAmountByUsageType, makeGetListAllVolumeAmountByUsageType } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import ModalCallType from '../../../../components/common/ModalCallType';
import ModalSearchMultiOrganization from '../../../../components/common/ModalSearchMultiOrganization';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class VoiceCustomerCallTypeSummary extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listVoiceCustomerCallTypeSummary: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listVoiceCustomerCallTypeSummary: props.listVoiceCustomerCallTypeSummary,
      totalCount: getPageTotalCount({ ...state, items: props.listVoiceCustomerCallTypeSummary }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetVoiceCustomerCallTypeSummaryReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetVoiceCustomerCallTypeSummaryReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listVolumeAmountByUsageType');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListVoiceCustomerCallTypeSummary();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListVoiceCustomerCallTypeSummary());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListVoiceCustomerCallTypeSummary());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListVoiceCustomerCallTypeSummary();
    });
  };

  doGetListVoiceCustomerCallTypeSummary = () => {
    const { filter, page, size, sorted } = this.state;
    const { getVolumeAmountByUsageType } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortVoiceCustomerCallTypeSummary[sorted.sortCol]
          ? sortVoiceCustomerCallTypeSummary[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getVolumeAmountByUsageType(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistVoiceCustomerCallTypeSummary = cb => {
    const { filter, sorted } = this.state;
    const { getListAllVolumeAmountByUsageType } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortVoiceCustomerCallTypeSummary[sorted.sortCol][sorted.sortDir] : null,
    };
    getListAllVolumeAmountByUsageType(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistVoiceCustomerCallTypeSummary(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllVoiceCustomerCallTypeSummary, t } = this.props;
        convertJson2Pdf({
          data: listAllVoiceCustomerCallTypeSummary,
          t,
          title: t('reportPage:sidebar.voiceCustomerCallTypeSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.voiceCustomerCallTypeSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistVoiceCustomerCallTypeSummary(() => {
      const { listAllVoiceCustomerCallTypeSummary, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_ACTIVE_SUBSCRIPTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.voiceCustomerCallTypeSummary')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.voiceCustomerCallTypeSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllVoiceCustomerCallTypeSummary,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllVoiceCustomerCallTypeSummary,
          t,
          title: t('reportPage:sidebar.voiceCustomerCallTypeSummary').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.voiceCustomerCallTypeSummary')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.voiceCustomerCallTypeSummary')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('VOICE_CUSTOMER_CALL_TYPE_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportVoiceCustomerCallTypeSummary,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listVoiceCustomerCallTypeSummary,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllVoiceCustomerCallTypeSummary,
      t,
      permissions: { modeGetVoiceCustomerCallTypeSummaryReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetVoiceCustomerCallTypeSummaryReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.voiceCustomerCallTypeSummary') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.voiceCustomerCallTypeSummary')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <VoiceCustomerCallTypeSummarySearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  ModalSearch={props => {
                    return (
                      <div>
                        <ModalCallType
                          isOpen={props.isOpen === 'usageType'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                          // accountId={id}
                        />
                        <ModalSearchMultiOrganization
                          isOpen={props.isOpen === 'organization'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                          selectFieldName="organization"
                          // accountId={id}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.voiceCustomerCallTypeSummary').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllVoiceCustomerCallTypeSummary,
                          t,
                          title: t('reportPage:sidebar.voiceCustomerCallTypeSummary').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.voiceCustomerCallTypeSummary')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listVoiceCustomerCallTypeSummary}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listVoiceCustomerCallTypeSummary && listVoiceCustomerCallTypeSummary.length
                      ? listVoiceCustomerCallTypeSummary
                      : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

VoiceCustomerCallTypeSummary.propTypes = {
  getVolumeAmountByUsageType: PropTypes.func,
  getListAllVolumeAmountByUsageType: PropTypes.func,
  listAllVoiceCustomerCallTypeSummary: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

VoiceCustomerCallTypeSummary.defaultProps = {
  getVolumeAmountByUsageType: () => {},
  getListAllVolumeAmountByUsageType: () => {},
  listAllVoiceCustomerCallTypeSummary: [],
};

const mapStateToProps = createStructuredSelector({
  listVoiceCustomerCallTypeSummary: makeGetListVolumeAmountByUsageType() || [],
  listAllVoiceCustomerCallTypeSummary: makeGetListAllVolumeAmountByUsageType() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getVolumeAmountByUsageType,
    getListAllVolumeAmountByUsageType,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(VoiceCustomerCallTypeSummary)
);
